import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import TrovaAgenteTemplate from 'react-components/templates/TrovaAgenteTemplate/TrovaAgenteTemplate'
import { PAGINEDETAIL } from 'utils/endpoint'
import { api } from 'utils'

const TrovaAgentePage = ({ pagina }) => {
  return (
    <>
      <MetaSeo seo={pagina?.seo} />
      <main className="trova-agente-page">
        <header className="trova-agente-page__header">
          <div className="w-container">
            <Breadcrumbs breadcrumbs={pagina?.breadcrumbs} />
          </div>
        </header>

        <TrovaAgenteTemplate />
      </main>
    </>
  )
}

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'trova-agente',
    },
  })
  const pagina = await pageResponse.data

  return { props: { pagina }, revalidate: 60 * 60 }
}

export default TrovaAgentePage
